import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=4d2171ef&"
import script from "./UserInfo.vue?vue&type=script&lang=js&"
export * from "./UserInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4d2171ef', component.options)
    } else {
      api.reload('4d2171ef', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=4d2171ef&", function () {
      api.rerender('4d2171ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserInfo/UserInfo.vue"
export default component.exports